import React, { useContext, useEffect } from 'react';
import AppContext from 'context/index';
import {
  TransactionDetails,
  UserDetails,
  LanguageConfig,
  Gallery,
  PaypalDetails,
  KpiDetails,
  AffiliateDetails,
  DigitalOcean,
  ProposalDetails,
  SignatureMails,
  WixRev,
  AIPrompt,
  SpamLinks,
  TestEnvironments,
} from './components';

import './Admin.scss';

const Admin = () => {
  const { selectedAdminTab } = useContext(AppContext);

  useEffect(() => {
    document.title = 'Prospero - Admin';
  });

  return (
    <div className="admin-content container">
      {selectedAdminTab === 'users' ? <UserDetails /> : null}
      {selectedAdminTab === 'props' ? <ProposalDetails /> : null}
      {selectedAdminTab === 'trans' ? <TransactionDetails /> : null}
      {selectedAdminTab === 'config' ? <LanguageConfig isConfigReady={true} /> : null}
      {selectedAdminTab === 'gallery' ? <Gallery /> : null}
      {selectedAdminTab === 'paypal' ? <PaypalDetails /> : null}
      {selectedAdminTab === 'kpi' ? <KpiDetails /> : null}
      {selectedAdminTab === 'affiliates' ? <AffiliateDetails /> : null}
      {selectedAdminTab === 'digital' ? <DigitalOcean /> : null}
      {selectedAdminTab === 'mails' ? <SignatureMails tab="mails" /> : null}
      {selectedAdminTab === 'reminder-emails' ? <SignatureMails tab="reminder-emails" /> : null}
      {selectedAdminTab === 'make_pdf' ? <SignatureMails tab="make_pdf" /> : null}
      {selectedAdminTab === 'wixrev' ? <WixRev /> : null}
      {selectedAdminTab === 'aiprompt' ? <AIPrompt /> : null}
      {selectedAdminTab === 'spam-links' ? <SpamLinks /> : null}
      {selectedAdminTab === 'test-envs' ? <TestEnvironments /> : null}
    </div>
  );
};

export default Admin;
